Jelly.Handlers = 
{
	// Initialize blank instance variables.
	
	// TODO: label these.
	Default_Target: null,	
	
	// Refresh Handlers
	Refresh_Handlers: [],
};